var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-main',[_c('GenericReport',{ref:"report",staticClass:"clean-list",attrs:{"orientation":"horizontal","hide-header":"","reportSpec":_vm.reportSpec},on:{"rowClicked":_vm.selectRow}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }